import React, { useEffect, useState } from "react";
import { Page, Text, View, Document, StyleSheet, Image, Font } from "@react-pdf/renderer";
import QRCode from "qrcode";
import logo from "../../../Pages/Images/SMJ_Logo.png";
import instalogo from "../../../Pages/Images/insta_logo.png";

// Promo page assets
import promoLogo from "../../../Pages/Images/SMJ_Logo.png";
import amazonLogo from "../../../Pages/Images/amazon.png";
import myntraLogo from "../../../Pages/Images/myntra.png";
import flipkartLogo from "../../../Pages/Images/flipkart.png";
import tickIcon from "../../../Pages/Images/tickicon.jpeg";
import diamondIcon from "../../../Pages/Images/diamond.png";
import sparkaleIcon from "../../../Pages/Images/Sparkle.png";
import giftIcon from "../../../Pages/Images/Gift.png";
import ringIcon from "../../../Pages/Images/Ring.jpeg";
import moneyIcon from "../../../Pages/Images/Money.jpg";
import voucherIcon from "../../../Pages/Images/Voucher.png";
import qrScanner from "../../../Pages/Images/QR1.png";


// ✅ Register fonts for second page
Font.register({
  family: "Helvetica",
});

Font.register({
  family: "Helvetica-Bold",
  src: "https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-bold-webfont.ttf",
});

// Helper function to format date/time
const formatDate = (date) => {
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
};

const formatTime = (date) => {
  let hours = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");
  const period = hours >= 12 ? "PM" : "AM";
  hours = hours % 12;
  hours = hours ? String(hours).padStart(2, "0") : "12";
  return `${hours}:${minutes}:${seconds} ${period}`;
};

// Existing dynamic styles (your current styles unchanged)
const styles = StyleSheet.create({
  page: { padding: 8, fontSize: 8, fontFamily: "Helvetica" },
  topRow: { flexDirection: "row", justifyContent: "space-between", alignItems: "center", marginBottom: 3 },
  smallBold: { fontSize: 8, fontFamily: "Helvetica-Bold" },
  logo: { width: 40, height: 40, marginHorizontal: 4 },
  title: { fontSize: 14, fontFamily: "Helvetica-Bold", textAlign: "center" },
  tagline: { fontSize: 9, fontStyle: "italic", textAlign: "center", marginTop: 4 },
  address: { fontSize: 8, marginTop: 5, textAlign: "center" },
  sup: { fontSize: 5, textBaseline: "alphabetic" },
  sectionRow: { flexDirection: "row", justifyContent: "space-between", marginTop: 8, paddingHorizontal: 2 },
  sectionLeft: { width: "60%" },
  sectionRight: { width: "40%", textAlign: "right" },
  label: { fontSize: 9, fontFamily: "Helvetica-Bold" },
  value: { fontSize: 8, marginBottom: 1 },
  table: { display: "table", width: "100%", borderWidth: 0.5, borderColor: "#000", marginTop: 6 },
  tableRow: { flexDirection: "row" },
  tableHeaderText: { fontSize: 8, color: "#fff", fontFamily: "Helvetica-Bold", textAlign: "center" },
  tableCell: { fontSize: 8, textAlign: "center" },
  colSNo: { width: "8%", borderWidth: 0.5, borderColor: "#000", padding: 2, justifyContent: "center" },
  colMetal: { width: "12%", borderWidth: 0.5, borderColor: "#000", padding: 2, justifyContent: "center" },
  colParticulars: { width: "38%", borderWidth: 0.5, borderColor: "#000", padding: 2, justifyContent: "center" },
  colNtWt: { width: "12%", borderWidth: 0.5, borderColor: "#000", padding: 2, justifyContent: "center" },
  colHSN: { width: "12%", borderWidth: 0.5, borderColor: "#000", padding: 2, justifyContent: "center" },
  colAmount: { width: "18%", borderWidth: 0.5, borderColor: "#000", padding: 2, justifyContent: "center" },
  summaryRow: { flexDirection: "row", marginTop: 6 },
  summaryRight: { flex: 1, borderWidth: 0.5, borderColor: "#000" },
  summaryHeader: { backgroundColor: "#000", flexDirection: "row" },
  summaryHeaderText: { flex: 1, color: "#fff", fontSize: 7, fontFamily: "Helvetica-Bold", textAlign: "center", padding: 2 },
  summaryRowItem: { flexDirection: "row", borderTopWidth: 0.5, borderColor: "#000" },
  summaryCell: { flex: 1, fontSize: 7, textAlign: "center", padding: 2 },
  noteSection: { marginTop: 6, marginBottom: 8 },
  noteHeading: { fontSize: 9, fontFamily: "Helvetica-Bold", marginBottom: 3 },
  noteText: { fontSize: 8, marginBottom: 2 },
  footer: { marginTop: 12, alignItems: "center" },
  thankYou: { fontSize: 11, fontFamily: "Helvetica-Bold", marginBottom: 4 },
  copyright: { fontSize: 8, marginTop: 6 },
});

// ✅ Updated Styles for static promo page (matching the image)
const promoStyles = StyleSheet.create({
  page: { padding: 8, fontSize: 8, fontFamily: "Helvetica" },
  topRow: { flexDirection: "row", justifyContent: "space-between", alignItems: "center" },
  smallBold: { fontSize: 8, fontFamily: "Helvetica-Bold" },
  logo: { width: 30, height: 30, marginHorizontal: 4 },
  title: { fontSize: 14, fontFamily: "Helvetica-Bold", textAlign: "center" },
  tagline: { fontSize: 9, fontStyle: "italic", textAlign: "center", marginTop: 4 },
  address: { fontSize: 8, marginTop: 5, textAlign: "center" },
  sup: { fontSize: 5, textBaseline: "alphabetic" },

  // Promo specific styles
  promoContainer: { marginTop: 8 },
  mainTitle: { fontSize: 12, fontFamily: "Helvetica-Bold", textAlign: "center", marginRight: 6 },
  subtitle: { fontSize: 9, textAlign: "center", marginBottom: 10, lineHeight: 1.3 },

  // Investment sections
  investmentSection: { marginBottom: 10 },
  investmentTitle: { fontSize: 12, fontFamily: "Helvetica-Bold", marginBottom: 4 },
  investmentSubtitle: { fontSize: 9, fontStyle: 'italic', marginBottom: 6 },
  featureItem: { flexDirection: 'row', alignItems: 'flex-start', marginBottom: 3 },
  checkbox: { width: 8, height: 8, borderWidth: 0.5, borderColor: '#000', marginRight: 4, marginTop: 1 },
  checkedCheckbox: { width: 8, height: 8, borderWidth: 0.5, borderColor: '#000', marginRight: 4, marginTop: 1, backgroundColor: '#000' },
  featureText: { fontSize: 9, lineHeight: 1.2, flex: 1 },

  // Footer
  footer: { marginTop: 8, alignItems: "center" },
  thankYou: { fontSize: 11, fontFamily: "Helvetica-Bold", marginBottom: 4 },
  copyright: { fontSize: 8, marginTop: 6 },
  separator: { borderTopWidth: 0.5, borderTopColor: '#000', marginVertical: 6 },
  instaRow: { flexDirection: "row", alignItems: "center", justifyContent: "center", marginTop: 4 },
  instaLogo: { width: 10, height: 10, marginRight: 3 },
  instaText: { fontSize: 8 },
});

const PDFContent = ({ entries, taxableAmount, taxAmount, netAmount, date, estimateNumber, sellerName }) => {

  const currentDate = new Date();
  const formattedDate = formatDate(currentDate);
  const currentTime = formatTime(currentDate);
  const taxPercent = parseFloat(entries[0]?.tax_percent || 0);
  const gstAmount = taxableAmount * (taxPercent / 100);
  const cgst = taxAmount / 2;
  const sgst = taxAmount / 2;
  const finalAmount = taxableAmount + gstAmount;


  return (
    <Document>
      {/* ================== PAGE 1 ================== */}
      <Page size={[300, 500]} style={styles.page}>
        {/* Top Row: GSTIN | Logo | Contact */}
        <View style={styles.topRow}>
          <Text style={styles.smallBold}>GSTIN: 29ADOPG5916E1ZE</Text>
          <Image src={logo} style={styles.logo} />
          <View>
            <Text style={styles.smallBold}>Contact: 916 916 9680</Text>
            <Text style={[styles.smallBold, { marginLeft: 33 }]}>080 26719107</Text>
          </View>
        </View>

        {/* Title + tagline + address */}
        <Text style={styles.title}>Sri Mahaganapathi Jewellers</Text>
        <Text style={[styles.tagline, { marginLeft: 50 }]}>
          Our Craft For Your Precious Stories
        </Text>
        <Text style={styles.address}>
          No 606, 14<Text style={styles.sup}>th</Text> Main Road, Siddanna Layout,
          BSK 2<Text style={styles.sup}>nd</Text> Stage
        </Text>

        {/* Estimation Details */}
        <View style={styles.sectionRow}>
          <View style={styles.sectionLeft}>
            <Text style={styles.label}>Estimation Details:</Text>
            <Text style={styles.value}>Estimation No: {entries[0]?.estimate_number || "N/A"}</Text>
            <Text style={styles.value}>Seller: {sellerName}</Text>
          </View>
          <View style={styles.sectionRight}>
            <Text style={styles.value}>Date: {formattedDate}</Text>
            <Text style={styles.value}>Time: {currentTime}</Text>
            <Text style={styles.value}>Rate: {entries[0]?.rate || "N/A"}</Text>
          </View>
        </View>

        {/* Items Table */}
    {/* Items Table */}
<View style={styles.table}>
  {/* Header */}
  <View style={styles.tableRow}>
    <View style={[styles.colSNo, { backgroundColor: "#000" }]}>
      <Text style={styles.tableHeaderText}>S.No</Text>
    </View>
    <View style={[styles.colMetal, { backgroundColor: "#000" }]}>
      <Text style={styles.tableHeaderText}>Metal</Text>
    </View>
    <View style={[styles.colParticulars, { backgroundColor: "#000" }]}>
      <Text style={styles.tableHeaderText}>Particulars / Gr. Wt</Text>
    </View>
    <View style={[styles.colNtWt, { backgroundColor: "#000" }]}>
      <Text style={styles.tableHeaderText}>WAW</Text>
    </View>
    <View style={[styles.colHSN, { backgroundColor: "#000" }]}>
      <Text style={styles.tableHeaderText}>HSN</Text>
    </View>
    <View style={[styles.colAmount, { backgroundColor: "#000" }]}>
      <Text style={styles.tableHeaderText}>Amount</Text>
    </View>
  </View>

  {/* Table Rows with MC and Stone Price below each item */}
  {entries.map((entry, index) => {
    // Use mc_per_gram for MC value
    const mcValue = parseFloat(entry.mc_per_gram || 0);
    const stonePrice = parseFloat(entry.stone_price || 0);

    return (
      <React.Fragment key={index}>
        {/* Main Item Row */}
        <View style={[styles.tableRow, { borderBottomWidth: 0 }]}>
          <View style={[styles.colSNo, { borderBottomWidth: 0 }]}>
            <Text style={styles.tableCell}>{index + 1}</Text>
          </View>
          <View style={[styles.colMetal, { borderBottomWidth: 0 }]}>
            <Text style={styles.tableCell}>{entry.metal_type || "Gold"}</Text>
          </View>
          <View style={[styles.colParticulars, { borderBottomWidth: 0 }]}>
            <Text style={styles.tableCell}>
              {entry.product_name || entry.sub_category} / {entry.gross_weight}g
            </Text>
          </View>
          <View style={[styles.colNtWt, { borderBottomWidth: 0 }]}>
            <Text style={styles.tableCell}>{entry.weight_bw || entry.total_weight_av}g</Text>
          </View>
          <View style={[styles.colHSN, { borderBottomWidth: 0 }]}>
            <Text style={styles.tableCell}>{entry.hsn_code || "7113"}</Text>
          </View>
          <View style={[styles.colAmount, { borderBottomWidth: 0 }]}>
            <Text style={styles.tableCell}>{entry.rate_amt}</Text>
          </View>
        </View>

        {/* MC and Stone Price Row for this item */}
        {(mcValue > 0 || stonePrice > 0) && (
          <View style={[styles.tableRow, { backgroundColor: "#f9f9f9", borderTopWidth: 0 }]}>
            <View style={[styles.colSNo, { justifyContent: "center", borderTopWidth: 0, borderBottomWidth: 0.5 }]}>
              <Text style={[styles.tableCell, { fontSize: 7, color: "#666" }]}></Text>
            </View>
            <View style={[styles.colMetal, { justifyContent: "center", borderTopWidth: 0, borderBottomWidth: 0.5 }]}>
              <Text style={[styles.tableCell, { fontSize: 7, color: "#666" }]}></Text>
            </View>
            <View style={[styles.colParticulars, { justifyContent: "center", borderTopWidth: 0, borderBottomWidth: 0.5 }]}>
              <View style={{ flexDirection: "row", justifyContent: "space-between" }}>
                <Text style={[styles.tableCell, { fontSize: 7, color: "#666", textAlign: "left" }]}>
                  MC: {mcValue.toFixed(2)}
                </Text>
                <Text style={[styles.tableCell, { fontSize: 7, color: "#666", textAlign: "right", marginLeft: 10 }]}>
                  Stn Rs. {stonePrice.toFixed(2)}
                </Text>
              </View>
            </View>
            <View style={[styles.colNtWt, { justifyContent: "center", borderTopWidth: 0, borderBottomWidth: 0.5 }]}>
              <Text style={[styles.tableCell, { fontSize: 7, color: "#666" }]}></Text>
            </View>
            <View style={[styles.colHSN, { justifyContent: "center", borderTopWidth: 0, borderBottomWidth: 0.5 }]}>
              <Text style={[styles.tableCell, { fontSize: 7, color: "#666" }]}></Text>
            </View>
            <View style={[styles.colAmount, { justifyContent: "center", borderTopWidth: 0, borderBottomWidth: 0.5 }]}>
              <Text style={[styles.tableCell, { fontSize: 7, color: "#666" }]}></Text>
            </View>
          </View>
        )}
      </React.Fragment>
    );
  })}
</View>

        {/* Summary Section */}
        <View style={styles.summaryRow}>
          <View style={styles.summaryRight}>
            <View style={styles.summaryHeader}>
              <Text style={styles.summaryHeaderText}>GST Calculation</Text>
              <Text style={styles.summaryHeaderText}>Amount</Text>
            </View>
            <View style={styles.summaryRowItem}>
              <Text style={styles.summaryCell}>Taxable Value</Text>
              <Text style={styles.summaryCell}>{taxableAmount}</Text>
            </View>
            <View style={styles.summaryRowItem}>
              <Text style={styles.summaryCell}>CGST @{(taxPercent / 2).toFixed(2)}%</Text>
              <Text style={styles.summaryCell}>{cgst}</Text>
            </View>
            <View style={styles.summaryRowItem}>
              <Text style={styles.summaryCell}>SGST @{(taxPercent / 2).toFixed(2)}%</Text>
              <Text style={styles.summaryCell}>{sgst}</Text>
            </View>
            <View style={styles.summaryRowItem}>
              <Text style={[styles.summaryCell, { fontFamily: "Helvetica-Bold" }]}>Final Amount</Text>
              <Text style={[styles.summaryCell, { fontFamily: "Helvetica-Bold" }]}>{netAmount}</Text>
            </View>
          </View>
        </View>

        {/* Note Section */}
        <View style={styles.noteSection}>
          <Text style={styles.noteHeading}>Note:</Text>
          <Text style={styles.noteText}>
            1. The estimate provided is based on the current gold, silver, and diamond rates on the date of issue.
          </Text>
          <Text style={styles.noteText}>
            2. Final billing will be done as per the prevailing rate on the date of purchase.
          </Text>
          <Text style={styles.noteText}>
            2. Making, stone, and other charges are subject to variation based on design and customization.
          </Text>
        </View>

        {/* Footer */}
        <View style={styles.footer}>
          <Text style={styles.thankYou}>Thank You | Visit Again</Text>
          <View style={{ flexDirection: "row", justifyContent: "space-between", width: "100%", alignItems: "center" }}>
            <View style={{ flexDirection: "row", alignItems: "center" }}>
              <Image
                src={instalogo}
                style={{ width: 12, height: 12, marginRight: 1, marginTop: 5 }}
              />
              <Text style={styles.copyright}>jewellers_srimahaganapathi</Text>
            </View>
            <Text style={styles.copyright}>SMJ Authorized Sign</Text>
          </View>
        </View>
      </Page>

      {/* ================== PAGE 2 (Promo Page - Updated to match image) ================== */}
      
    </Document>
  );
};

export default PDFContent;